var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("404 - It's not here :(")]),_c('v-card-text',[_vm._v("Whatever you were looking for doesn't seem to be here, please verify the url or link and try again.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }